module.exports = __webpack_public_path__ + "img/banner.d87cd298.png";